<template>
    <v-container>
        <Header
            :registryStatus="getTendersStatuses"
            :recordIndex="getTendersDetails.index"
            :registryTitle="getTendersRegistry.name"
            :registryUrl="'tenders'"
            :actualStatus="getTendersDetails.status"
            :avatarData="getTendersDetails.createdBy"
            @status-changed="changeStatus"
        ></Header>
        <Main :items="items" class="p-relative">
            <v-tab-item
                v-for="item in items"
                :key="item.id"
                slot="tabItems"
                :id="item.id"
            >
                <component :is="item.component"></component>
            </v-tab-item>
            <div slot="information">
                <Information />
                <Modal
                    :title="$t('tenders:edition')"
                    :open="open"
                    :height="'520'"
                    v-on:close="closeModal()"
                >
                    <AEContent slot="AEContent" />
                    <Buttons
                        @closeModal="open = false"
                        :action="'edit'"
                        slot="buttons"
                    />
                </Modal>
                <div class="d-flex justify-end buttons--details">
                    <v-tooltip left>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                fab
                                dark
                                v-on="on"
                                v-if="edit()"
                                small
                                @click="editTender()"
                                class="buttons--add margin--1"
                            >
                                <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('tenders:edit') }}</span>
                    </v-tooltip>
                </div>
            </div>
        </Main>
    </v-container>
</template>

<script>
import store from './../../../store/index'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Information from '../../../components/Registries/Tenders/Details/Information.vue'
import AEContent from './../../../components/Registries/Tenders/Modal/Content'
import Buttons from './../../../components/Registries/Tenders/Modal/Buttons'

export default {
    i18nOptions: { namespaces: ['global'] },
    components: {
        Information,
        AEContent,
        Buttons,
    },
    data() {
        return {
            open: false,
            items:[],
        }
    },
    computed: {
        ...mapGetters([
            'getTendersStatuses',
            'getTendersRegistry',
            'getTendersDetails',
        ]),
    },
    methods: {
        ...mapMutations([
            'setTendersDetails',
            'setTendersStatuses',
            'setTendersRegistry',
            'setTendersModal',
            'clearTendersErrors',
            'clearRepresentativesInput',
            'clearTendersModal'
        ]),
        ...mapActions(['fetchTenders', 'updateTendersStatus']),
        changeStatus(status) {
            this.updateTendersStatus({ status, id: this.getTendersDetails._id })
        },
        edit() {
            return this.checkPermissions('UPDATE')
        },
        async editTender() {
            this.open = true
            this.clearTendersErrors()
            this.setTendersModal()
        },
        closeModal() {
            this.open = false
            this.clearTendersErrors()
            this.clearRepresentativesInput()
            this.clearTendersModal()
        },
    },
    beforeRouteEnter(to, from, next) {
        store.dispatch('fetchTenders', { id: to.params.id, next })
    },
}
</script>
